// extracted by mini-css-extract-plugin
module.exports = {"segments":"styles_segments__2yQjc","button":"styles_button__17DiD"};